import auth from '../../middlewares/auth';

export const inventoryRoutes = [
  {
    path: '/inventories',
    component: () =>
      import(
        /* webpackChunkName: "inventories" */ '../../views/inventories/Inventory'
      ),
    name: 'inventories',
    meta: {
      middleware: [auth],
      requiredPermissions: ['inventory-manage'],
    },
  },
  {
    path: '/inventory/:id',
    component: () =>
      import(
        /* webpackChunkName: "inventories" */ '../../views/inventories/InventoryForm'
      ),
    name: 'update-inventory',
    meta: {
      middleware: [auth],
      requiredPermissions: ['inventory-manage'],
    },
  },
  {
    path: '/create-inventory',
    component: () =>
      import(
        /* webpackChunkName: "inventories" */ '../../views/inventories/InventoryForm'
      ),
    name: 'create-inventory',
    meta: {
      middleware: [auth],
      requiredPermissions: ['inventory-manage'],
    },
  },
];
